import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth";

export default function LoginCallback() {
  const [searchParams] = useSearchParams();
  const { handleCallback } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = searchParams.get("code");
    const errorParam = searchParams.get("error_description") || searchParams.get("error");

    if (errorParam) {
      setError(errorParam);
      return;
    }

    if (code) {
      handleCallback(code)
        .then(() => navigate("/edit", { replace: true }))
        .catch((err) => setError(err.message));
    } else {
      setError("No authorization code received");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md text-center">
          <p className="text-red-700 font-medium">Sign in failed</p>
          <p className="text-red-600 text-sm mt-2">{error}</p>
          <a
            href="/login"
            className="inline-block mt-4 text-primary-500 hover:underline text-sm"
          >
            Try again
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-500">Signing you in...</p>
    </div>
  );
}
